import Vue from "vue";
import VeeValidate from "vee-validate";
import { firestorePlugin } from "vuefire";
import VueMoment from "vue-moment";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

import VueResource from "vue-resource";
Vue.use(VueResource);

Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(VeeValidate);
Vue.use(VueMoment);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
